export default __webpack_public_path__ + "static/media/pickup.59306f1e.svg";